import "./form-rate-per-pax.scss";

import { RatePerPaxFormSchema } from "@factory/form/form.rule";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import { useFormContext } from "react-hook-form";
import { useParams } from "react-router-dom";

type InputFormSchema = RatePerPaxFormSchema;
export function FormRatePerPax() {
  const { control, setValue } = useFormContext<RatePerPaxFormSchema>();
  const { activityId } = useParams();
  setValue("activity", activityId || "");
  return (
    <div id="FormRatePerPax" className="rate-per-pax">
      <InputDigitControl<InputFormSchema>
        control={control}
        name="number"
        label="Number"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter number"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="sizeDescription"
        label="Size Description"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter sizeDescription"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="childRate"
        label="Rate per Child"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter amount"
      />
      {/* <InputDigitControl<InputFormSchema>
        control={control}
        name="senior_rate"
        label="Amount"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter amount"
      /> */}
      <InputDigitControl<InputFormSchema>
        control={control}
        name="totalAmount"
        label="Total Amount"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter totalAmount"
      />
    </div>
  );
}

export default FormRatePerPax;
